
const bundleSubmitButton = document.querySelector("#bundle_submit_button");
const bundleForm = document.querySelector("form.bundle_form");
const productCards = bundleForm?.querySelectorAll("product-card.product-card ");
const marketHandle = bundleForm.getAttribute("market");

let addedToCart = false;
if (bundleForm) {
  const disableFormButton = () => {
    bundleSubmitButton.setAttribute("disabled", true);
    bundleSubmitButton.classList.add("disabled");
  }

  const toggleFormButton = () => {
    const checkboxes = bundleForm.querySelectorAll("input[type='checkbox']");
    let checkedMainProduct = checkboxes[0].checked;
    let checkedLeastSubProduct = false;
    
    for (let i = 1; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          checkedLeastSubProduct = true;
          break;
        }
    }

    // Color Controled by CSS
    if (!checkedMainProduct || !checkedLeastSubProduct) {
      bundleSubmitButton.setAttribute("disabled", true);
      bundleSubmitButton.classList.add("disabled");
    } else {
      bundleSubmitButton.removeAttribute("disabled");
      bundleSubmitButton.classList.remove("disabled");
      addedToCart = false;
    }
    
  }
    const sumPrices = (checkedArr, priceArr) => {
      let price = 0;
      for (let i = 0; i < checkedArr.length; i++) {
        if (checkedArr[i].checked) {
          let checkedPrice = priceArr[i].innerText || priceArr[i].textContent;
          checkedPrice = checkedPrice.replace("From ", "");
          const splitedCheckPrice= checkedPrice.split(" ");
          let p = splitedCheckPrice.find(e => e.includes("$"));
          let currency = splitedCheckPrice.find(e => e.includes("D"));
          const number = p.match(/[0-9.,]+/)[0].replace(/,/g, '');
          price += parseFloat(number);
        }
    }
      return price;
    }
    
  const updatePrice = () => {
    const checkboxes = bundleForm.querySelectorAll("input[type='checkbox']");
    const prices = bundleForm.querySelectorAll("sale-price .money");
    const findAltPrices = () => {
      return bundleForm.querySelectorAll("sale-price.text-subdued span.sr-only");
    }
    let altPrices;
    if (prices.length === 0) {
      altPrices = Array.from(findAltPrices()).map(e => e.nextSibling);
    } 
    
    const total = document.querySelector(".bundle_total_discounted_price");
      let price = prices.length === 0 ? sumPrices(checkboxes, altPrices) : sumPrices(checkboxes, prices);
    total.innerText = new Intl.NumberFormat('en-CA', { style: 'currency', currency: "CAD" }).format(price.toFixed(2));
  }
/**

  // bundle swatch option handler
  const swatch = bundleForm.querySelector(".variant-picker__option-values");
    if (swatch) {

    swatch.addEventListener("click", (e) => {
      const target = e.target;
      const bdOptions = bundleForm.querySelectorAll(".option_bd");
      const beOptions = bundleForm.querySelectorAll(".option_be");
      const bdSelects = bundleForm.querySelectorAll("select[custom-type='Shipping']");
      const shippingMethod = target.getAttribute("shipping-method");
      const shippingMethodTitle = bundleForm.querySelector(".variant-picker__option-info span");
      const currentShippingMethod = shippingMethodTitle.innerText;
      if (currentShippingMethod != shippingMethod) {
        shippingMethodTitle.innerText = shippingMethod;
      } 

      if (shippingMethod) {  
        if (marketHandle == "us") {
          const subTotalWrapper = document.querySelector(".bundle_total_discounted_price_wrapper");
          const bundleBuyButtonWrapper = document.querySelector(".bundle_buy_button_wrapper");
          const chatButton = document.querySelector("buy-buttons.buy-buttons-alt-chat-us");
          if (shippingMethod == "Bigtent Direct") {
            subTotalWrapper.style.display = "none";
            bundleBuyButtonWrapper.style.display = "none";
            chatButton.style.display = "block";
          } else {
            subTotalWrapper.style.display = "block";
            bundleBuyButtonWrapper.style.display = "block";
            chatButton.style.display = "none";
          }
        }
        Array.from(bdSelects).map((select) => {
          const selectedOptionIndex = select.selectedIndex;
          const options = select.querySelectorAll("option");
          const optionsArr = Array.from(options);
          const currentSelectedOptionText = optionsArr[selectedOptionIndex].innerText;
              optionsArr.map((option ) => {
                if (option.getAttribute("shipping-method") == shippingMethod ) {
                  option.style.display = "block";
                  if (option.innerText == currentSelectedOptionText || option.innerText == shippingMethod) {
                    select.selectedIndex = option.index;
                    select.setAttribute("value", option.value);
                  } 
                } else {
                  option.style.display = "none";
                }
          }) 
          
        });
      }
    });
      const firstInput = swatch.querySelector("input[shipping-method]");
      firstInput?.click();

    }
*/
    const selects = bundleForm.querySelectorAll("select");
    const selectsArr = Array.from(selects);
    selectsArr.length > 0 && Array.from(selects)?.map(select => select.addEventListener("change", (e) => {
      const target = e.target;
      const priceOfTarget = (target.options[target.selectedIndex].getAttribute("price")/100);
      const priceWithSymbol = new Intl.NumberFormat('en-US', { style: 'currency', currency: "USD" }).format(priceOfTarget.toFixed(2));
      
      // find parentNode
      const parent = e.target.parentNode;
      const salePriceNode = parent.querySelector("sale-price");
      const money = parent.querySelector("sale-price .money");
          salePriceNode.childNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE & node.textContent.trim().length > 2) {
              if (node.textContent.includes('From')) {
                node.textContent = node.textContent.replace("From ", "");
              } 
                
                if (!money & node.textContent.length > 1) {
                  const words = node.textContent.split(" ");
                  node.textContent = priceWithSymbol + " " + words.at(-1); 
                }
            }
          
          });
      if (money) { 
        const [p, currency] = money.innerText.split(" ");
        money.innerText = priceWithSymbol + " " + currency;
      }
    }))

  const updateForm = () => {
    toggleFormButton();
    updatePrice();
    if (!addedToCart) {
              bundleSubmitButton.querySelector("div").innerText = "Add to cart";
    }
  }

  const resetBundleForm = async () => {
    const checkedBoxes = bundleForm.querySelectorAll("input[type='checkbox']:checked");
    Array.from(checkedBoxes).map(checkbox => checkbox.checked = false);

  }


  const addToCart = async(requestBody) => {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });


    const responseJson = await res.json();
    if (res.ok) {
        if (requestBody.items[0].code.length > 1) {
          const response = await fetch(`${window.Shopify.routes.root}discount/${requestBody.items[0].code}`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
              },
          });
          if (response.ok) {
            console.log("DISCOUNT APPLIED")
          } else {
            console.log("FAILED APPLYING DISCOUNT ")
          }
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        
        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
          return window.location.href = `${window.Shopify.routes.root}cart`;
        }
        
        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));

        return true;
      } else {
        return false;
      }
  }
    
    bundleForm.addEventListener("change", updateForm);
    bundleSubmitButton.addEventListener("click", (e) => {
    const productData = [];
    Array.from(productCards).map((productCard, index) => {
      const checkedInput = productCard.querySelector("input:checked");
      if (checkedInput) {
        const id = parseInt(checkedInput.value);
        let code = checkedInput.getAttribute("code");
        if (!code) {
          code = "";
        }
        let variantId;
        if (productCard.querySelector("select")) {
          variantId = parseInt(productCard.querySelector("select").value);
        } else {
          variantId = parseInt(productCard.querySelector("span.selectedID").getAttribute("value"));
        }
        productData.push({
          id: variantId,
          quantity: 1,
          variantId: parseInt(variantId),
          code
        })
      }
    })
    
    const requestBody = {
      items: productData,
    };

    if (requestBody.items.length < 1) {
      return;
    } else {
      // Get updated cart data
      const waitResponse = async() => {
      disableFormButton();
      addedToCart = await addToCart(requestBody);
      if (addedToCart) {
          resetBundleForm();
          // updateForm();
          bundleSubmitButton.querySelector("div").innerText = "Added";
      }
        
      }
      waitResponse();
      
    }
  })
                      

  // UPDATE SELECT VALUE
  const selections = bundleForm.querySelectorAll("select");
  selections.forEach(select => {
    select.addEventListener("change", (e) => {
      const val = e.target.value;
      select.setAttribute("value", val);
    })
  })

}
